import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import _ from "lodash";
import React, {Component, ComponentElement} from "react";
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {ActionCreator} from "../../../../../actions/actions";

import {Dialog} from "../../../../../utils/Dialog/Dialog.component";
import {ConfigurationsActionCreators} from "../../../actions/actionCreators";
import {ConfigurationSchema} from "../../../reducers/schema.reducer";
import {configurationsStoreSelectors} from "../../../store/store";

import AccountingConfigurationSection from "./AccountingConfigurationSection/AccountingConfigurationSection.component";
import ConfigurationStepper from "./ConfigurationStepper/ConfigurationStepper.component";
import GlobalJackpotConfigurationSection
    from "./GlobalJackpotConfigurationSection/GlobalJackpotConfigurationSection.component";
import GroupsConfigurationSection from "./GroupsConfigurationSection/GroupsConfigurationSection.component";
import MailingConfigurationSection from "./MailingConfigurationSection/MailingConfigurationSection.component";
import MailSenderConfigurationSection from "./MailSenderConfigurationSection/MailSenderConfigurationSection.component";

import "./NewConfigurationPage.component.scss";

import ProgressivesConfigurationSection
    from "./ProgressivesConfigurationSection/ProgressivesConfigurationSection.component";
import SettingsConfigurationSection from "./SettingsConfigurationSection/SettingsConfigurationSection.component";
import SoundsConfigurationSection from "./SoundsConfigurationSection/SoundsConfigurationSection.component";
import SpecialPrizesConfigurationSection
    from "./SpecialPrizesConfigurationSection/SpecialPrizesConfigurationSection.component";
import MegapotConfigurationSection
    from "./MegapotConfigurationSection/MegapotConfigurationSection.component";

export const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};

export interface NewConfigurationPageProps extends RouteComponentProps {
    getLatestSchema: ActionCreator;
    getConfiguration: ActionCreator;
    clearConfiguration: ActionCreator;
    clearConfigurationSubmition: ActionCreator;
    clearSchema: ActionCreator;
    schema: ConfigurationSchema;
    schemaLoading: boolean;
    editingConfiguration: any;
    existingConfiguration: any;
    editingConfigurationLoading: boolean;
    getSoundsServer: ActionCreator;
    sounds: any;
    editConfiguration: ActionCreator;
    createConfiguration: ActionCreator;
    submitingConfigurationLoading: any;
    submitingConfigurationState: any;
    configFormValid: any;
    uploadedConfiguration: any;
    getRegions: ActionCreator;
    regionsLoading: boolean;
    getMailingLists: ActionCreator;
    progressiveRules: any;
    getProgressivesRules: ActionCreator;
}

export interface SectionConfig {
    name: string;
    id: string;
    component: ComponentElement<any, any>;
}

export interface NewConfigurationPageState {
    pages: SectionConfig[];
    selectedPage: SectionConfig;
    definedPages: boolean;
    visible: boolean;
    cancelDialog: boolean;
    showUnchangedDialog: boolean;
    showStrayGroupsDialog: boolean;
    errorConfig: boolean;
}

let localPages = [
    {
        id: "settings",
        name: "Settings",
        component: <SettingsConfigurationSection key="settings"/>
    },
    {
        id: "accounting",
        name: "Accounting",
        component: <AccountingConfigurationSection key="accounting"/>
    },

    {
        id: "groups",
        name: "Groups",
        component: <GroupsConfigurationSection key="groups"/>
    },

    {
        id: "progressives",
        name: "Progressives",
        component: <ProgressivesConfigurationSection key="progressives"/>
    },
    {
        id: "specialPrizes",
        name: "Special Prizes",
        component: <SpecialPrizesConfigurationSection key="specialPrizes"/>
    },
    {
        id: "mailingList",
        name: "Mailing Lists",
        component: <MailingConfigurationSection key="mailingList"/>
    },
    {
        id: "mailSender",
        name: "Email Sender",
        component: <MailSenderConfigurationSection key="mailSender"/>
    },
    {
        id: "sounds",
        name: "Sounds",
        component: <SoundsConfigurationSection key="sounds"/>
    }
];

const settingsPage = [
    {
        id: "settings",
        name: "Settings",
        component: <SettingsConfigurationSection key="settings"/>
    },
    {
        id: "mailingList",
        name: "Mailing Lists",
        component: <MailingConfigurationSection key="mailingList"/>
    },
    {
        id: "mailSender",
        name: "Email Sender",
        component: <MailSenderConfigurationSection key="mailSender"/>
    }
];

const globalPages = [
    {
        id: "globalJackpot",
        name: "Global",
        component: <GlobalJackpotConfigurationSection key="globalJackpots"/>
    }
];

const megapotPage = {
    id: "megapot",
    name: "Megapot",
    component: <MegapotConfigurationSection key="megapot"/>
};

class NewConfigurationPage extends Component<
    NewConfigurationPageProps,
    NewConfigurationPageState
> {
    private didFetchSounds = false;
    private isDetail = false;
    private didFetchMailing = false;
    private didFetchSubsidiaries = false;

    constructor(props) {
        super(props);

        this.state = {
            selectedPage: undefined,
            pages: [],
            definedPages: false,
            visible: false,
            cancelDialog: false,
            showUnchangedDialog: false,
            showStrayGroupsDialog: false,
            errorConfig: false
        };

        this.isDetail = this.props.match.path.includes("/detail");

        if (
            this.props.match.params["uploadingServer"] !== null &&
            this.props.match.params["uploadingServer"] !== undefined &&
            this.props.uploadedConfiguration == null
        ) {
            this.props.history.push(`/halls`);
        }
    }

    componentDidMount() {
        const {params} = this.props.match;

        this.setState({
            visible: true
        });

        if (params["editingServer"] && params["editingConfig"]) {
            this.props.getConfiguration({
                serverId: params["editingServer"],
                hallId: params["hallId"],
                config: params["editingConfig"],
                isDetail: this.isDetail
            });
        } else if (params["editingServer"]) {
            this.props.getLatestSchema({
                serverId: params["editingServer"]
            });
        } else if (params["uploadingServer"]) {
            this.props.getConfiguration({
                serverId: params["uploadingServer"],
                hallId: null,
                config: null,
                isDetail: this.isDetail,
                update: this.props.uploadedConfiguration
            });
        }

        if (
            this.props.editingConfiguration.subsidiary &&
            this.props.editingConfiguration.subsidiary.id &&
            this.props.editingConfiguration.settings.settings.settings !== null
        ) {
            this.didFetchSubsidiaries = true;
            this.props.getProgressivesRules(
                this.props.editingConfiguration.subsidiary.id,
                this.isDetail,
                "point_system" in this.props.editingConfiguration.settings.settings.settings ? this.props.editingConfiguration.debug_mode : true
            );
            this.props.getRegions(
                this.props.editingConfiguration.subsidiary.id
            );
        }
    }

    componentDidUpdate() {
        if (
            this.props.editingConfiguration.subsidiary &&
            this.props.editingConfiguration.subsidiary.id
        ) {
            if (
                !this.didFetchSounds &&
                this.props.sounds.length == 0 &&
                (this.props.match.params["editingConfig"] == undefined ||
                    (this.props.match.params["editingConfig"] !== undefined &&
                        this.props.editingConfiguration.settings.version !==
                        undefined))
            ) {
                this.didFetchSounds = true;
                this.props.getSoundsServer({
                    serverId: this.props.match.params["editingServer"]
                        ? this.props.match.params["editingServer"]
                        : this.props.match.params["uploadingServer"],
                    subsidiary: this.props.editingConfiguration.subsidiary.id,
                    version:
                        this.props.editingConfiguration.settings.version ===
                        undefined
                            ? null
                            : this.props.editingConfiguration.settings.version
                });
            }

            if (
                !this.didFetchMailing &&
                !this.isDetail &&
                this.props.editingConfiguration.settings.settings.settings !==
                null &&
                this.props.match.params["editingServer"] &&
                this.props.match.params["editingConfig"]
            ) {
                this.props.getMailingLists(
                    this.props.editingConfiguration.subsidiary.id
                );
                this.didFetchMailing = true;
            }

            if (!this.didFetchSubsidiaries && this.props.editingConfiguration.settings.settings.settings !== null) {
                this.didFetchSubsidiaries = true;
                this.props.getProgressivesRules(
                    this.props.editingConfiguration.subsidiary.id,
                    this.isDetail,
                    "point_system" in this.props.editingConfiguration.settings.settings.settings ? this.props.editingConfiguration.debug_mode : true
                );
                this.props.getRegions(
                    this.props.editingConfiguration.subsidiary.id
                );
            }
        }
    }

    componentWillUnmount() {
        this.props.clearSchema();
        this.props.clearConfiguration();
    }

    onSelect = page => {
        this.setState({
            selectedPage: page
        });
    };

    nextPage = () => {
        const index = this.state.pages.indexOf(this.state.selectedPage);
        if (index !== -1 && index + 1 < this.state.pages.length) {
            this.setState({
                selectedPage: this.state.pages[index + 1]
            });
        }
    };

    previousPage = () => {
        const index = this.state.pages.indexOf(this.state.selectedPage);
        if (index !== -1 && index - 1 >= 0) {
            this.setState({
                selectedPage: this.state.pages[index - 1]
            });
        }
    };

    cancelConfig = () => {
        //this.props.clearConfiguration();
        this.props.history.push(
            `/halls/${this.props.editingConfiguration.hall_id}/servers/${this.props.editingConfiguration.id}`
        );
    };

    clickCancel = () => {
        if (!this.props.submitingConfigurationLoading) {
            const {params} = this.props.match;
            if (params["editingServer"] && params["editingConfig"]) {
                this.cancelConfig();
            } else if (this.state.errorConfig) {
                this.props.history.push('/home');
            } else {
                this.setState({
                    cancelDialog: true
                });
            }
        }
    };

    closeCancelDialog = () => {
        this.setState({
            cancelDialog: false
        });
    };

    cancelUnchangedDialog = () => {
        this.setState({
            showUnchangedDialog: false
        });
    };

    closeSubmitingDialog = () => {
        this.props.clearConfigurationSubmition();
    };

    cancelStrayGroupsDialog = () => {
        this.setState({
            showStrayGroupsDialog: false
        });
    };

    continueStrayGroupsDialog = () => {
        this.setState({
            showStrayGroupsDialog: false
        });
        this.createConfig();
    };

    confirmSubmitSuccess = () => {
        const hallId = this.props.editingConfiguration.hall_id;
        const serverId = this.props.editingConfiguration.id;
        this.props.clearConfigurationSubmition();
        this.props.clearConfiguration();

        this.props.history.push(`/halls/${hallId}/servers/${serverId}`);
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.schema !== null &&
            props.schema !== undefined &&
            state.definedPages === false
        ) {
            let errorConfig = false
            if (props.editingConfiguration && props.match.params["hallId"] && props.editingConfiguration.hall_id != props.match.params["hallId"]) {
                errorConfig = true
            }
            let pages = [];
            if (
                props.schema.components.megapot
            ) {
                pages = localPages;
                 if (pages[4]["id"] != megapotPage.id) pages.splice(4, 0, megapotPage);
            } else if (
                Object.keys(props.schema.components).length == 3 &&
                props.schema.components.global_jackpot
            ) {
                pages = settingsPage.concat(globalPages);
            } else if (Object.keys(props.schema.components).length == 9) {
                pages = localPages.concat(globalPages);
            } else {
                pages = localPages;
            }

            const indexMailingList = pages.findIndex(page => page.id === "mailingList")
            if (indexMailingList > -1) {
                pages[indexMailingList].component =
                    <MailingConfigurationSection key="mailingList" isDetails={props.match.path.includes("/detail")}/>
            }

            return {
                pages,
                selectedPage: pages[0],
                definedPages: true,
                errorConfig
            };
        }

        return null;
    }

    configSounds = game_types => {
        const groupedByGame = _.groupBy(
            this.props.sounds.filter(sound => {
                return game_types.includes(GAME_TYPES[sound.game.type]);
            }),
            "identifier"
        );

        return Object.keys(groupedByGame).map(identifier => {
            return {
                identifier: parseInt(identifier),
                groups: groupedByGame[identifier].map(group => {
                    return {
                        id: group.id,
                        level: group.level,
                        sub_level: group.sub_level_enabled
                            ? group.sub_level
                            : null
                    };
                })
            };
        });
    };

    confirmStrayGroups = () => {
        if (!this.props.submitingConfigurationLoading) {
            if (this.props.match.params["uploadingServer"]) {
                this.createConfig();
            } else {
                if (this.checkForStrayGroups()) {
                    this.setState({
                        showStrayGroupsDialog: true
                    });
                } else {
                    this.createConfig();
                }
            }
        }
    };

    checkForStrayGroups = () => {
        const selectGroupType =
            this.props.editingConfiguration.settings.selectedGroupType;
        const groups =
            selectGroupType == "terminal"
                ? this.props.editingConfiguration.settings.settings
                .terminal_groups || []
                : this.props.editingConfiguration.settings.settings
                .game_groups || [];
        let usedGroups = [];

        this.props.editingConfiguration.settings.settings.progressives.map(
            pg => {
                if (selectGroupType == "terminal") {
                    usedGroups = usedGroups.concat(pg.terminal_groups);

                    if (
                        pg.type === "levels" ||
                        pg.type === "multipots" ||
                        pg.type === "jumbolink" ||
                        pg.type === "reelstrike" ||
                        pg.type === "easylink" ||
                        pg.type === "sap" ||
                        pg.type === "luckytokenslink"
                    ) {
                        pg["children"].map(child => {
                            if (
                                child.hasOwnProperty("terminal_groups") &&
                                child.terminal_groups !== null &&
                                child.terminal_groups !== undefined
                            ) {
                                usedGroups = usedGroups.concat(
                                    child.terminal_groups
                                );
                            }
                        });
                    }
                } else if (selectGroupType == "game") {
                    usedGroups = usedGroups.concat(pg.game_groups);

                    if (
                        pg.type === "levels" ||
                        pg.type === "multipots" ||
                        pg.type === "jumbolink" ||
                        pg.type === "reelstrike" ||
                        pg.type === "easylink" ||
                        pg.type === "sap" ||
                        pg.type === "luckytokenslink"
                    ) {
                        pg["children"].map(child => {
                            if (
                                child.hasOwnProperty("game_groups") &&
                                child.game_groups !== null &&
                                child.game_groups !== undefined
                            ) {
                                usedGroups = usedGroups.concat(
                                    child.game_groups
                                );
                            }
                        });
                    }
                }
            }
        );

        this.props.editingConfiguration.settings.settings.special_prizes.map(
            pg => {
                if (selectGroupType == "terminal") {
                    usedGroups = usedGroups.concat(pg.terminal_groups);
                } else if (selectGroupType == "game") {
                    usedGroups = usedGroups.concat(pg.game_groups);
                }
            }
        );

        usedGroups = _.uniq(usedGroups);
        return usedGroups.length < groups.length;
    };

    createConfig = () => {
        const {params} = this.props.match;

        if (!this.props.submitingConfigurationLoading) {
            if (params["editingServer"] && params["editingConfig"]) {
                if (
                    _.isEqual(
                        _.omit(this.props.editingConfiguration, [
                            "settings.settings.game_groups",
                            "settings.settings.terminal_groups",
                            "settings.settings.sounds"
                        ]),
                        _.omit(this.props.existingConfiguration, [
                            "settings.settings.game_groups",
                            "settings.settings.terminal_groups",
                            "settings.settings.sounds"
                        ])
                    ) &&
                    _.isEqual(
                        this.configSounds(
                            this.props.editingConfiguration.settings.settings
                                .settings.game_types
                        ),
                        this.props.existingConfiguration.settings.settings
                            .sounds
                    ) &&
                    (this.props.editingConfiguration.settings.settings
                        .game_groups !== undefined
                        ? _.isEqual(
                            this.props.existingConfiguration.settings.settings
                                .jackpot_groups.game_groups,
                            this.props.editingConfiguration.settings.settings
                                .game_groups
                        )
                        : _.isEqual(
                            this.props.existingConfiguration.settings.settings
                                .jackpot_groups.game_groups,
                            this.props.editingConfiguration.settings.settings
                                .jackpot_groups.game_groups
                        )) &&
                    (this.props.editingConfiguration.settings.settings
                        .terminal_groups !== undefined
                        ? _.isEqual(
                            this.props.existingConfiguration.settings.settings
                                .jackpot_groups.terminal_groups,
                            this.props.editingConfiguration.settings.settings
                                .terminal_groups
                        )
                        : _.isEqual(
                            this.props.existingConfiguration.settings.settings
                                .jackpot_groups.terminal_groups,
                            this.props.editingConfiguration.settings.settings
                                .jackpot_groups.terminal_groups
                        ))
                ) {
                    this.setState({
                        showUnchangedDialog: true
                    });
                } else {
                    this.props.editConfiguration({
                        serverId: this.props.match.params["editingServer"],
                        config: this.props.match.params["editingConfig"]
                    });
                }
            } else if (this.props.match.params["uploadingServer"]) {
                this.props.createConfiguration({
                    serverId: this.props.match.params["uploadingServer"]
                });
            } else {
                this.props.createConfiguration({
                    serverId: this.props.match.params["editingServer"]
                });
            }
        }
    };

    checkValid = _.memoize(({configFormValid}) => {
        let valid = {
            settings: false,
            accounting: false,
            groups: false,
            progressives: false,
            specialPrizes: false,
            mailingList: false,
            ...configFormValid
        };

        if (valid.specialPrizes) valid.specialPrizes=true;
        if (
            Object.keys(this.props.schema.components).length == 2 &&
            this.props.schema.components.global_jackpot
        ) {
            return (
                configFormValid.settings == true &&
                configFormValid.globalJackpot
            );
        }
        if (
            !("megapot" in this.props.schema.components)
        ) {
            delete valid['megapot']
        }
        if (
            !("globalJackpot" in this.props.schema.components)
        ) {
            delete valid['globalJackpot']
        }

        return Object.values(valid).every(value => value === true);
    });

    render() {
        let hasOnlyNext = false;
        let hasOnlyPrev = false;

        if (this.state.errorConfig) {
            return (
                <div id="NewConfigurationPage" className="visible">
                    <div className="sidebar-layout">
                        <div className="container header" style={{textAlign: "end"}}>
                            <button onClick={this.clickCancel}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className="error-config">
                        Configuration does not exist for selected server.
                    </div>
                </div>
            );
        } else if (
            this.props.schemaLoading ||
            this.props.editingConfigurationLoading ||
            this.props.regionsLoading ||
            this.state.pages.length == 0
        ) {
            return (
                <div id="NewConfigurationPage" className="visible">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100}/>
                    </div>
                </div>
            );
        } else {
            hasOnlyNext =
                this.state.pages.length < 2 ||
                this.state.selectedPage.id === "settings";
            hasOnlyPrev =
                this.state.pages.length < 2 ||
                this.state.selectedPage.id ===
                this.state.pages[this.state.pages.length - 1].id;

            return (
                <div
                    id="NewConfigurationPage"
                    className={this.state.visible ? "visible" : ""}
                >
                    <div className="sidebar-layout">
                        <div className="config-content">
                            <div className="container header">
                                <h1>
                                    {this.isDetail
                                        ? "Configuration Details for"
                                        : "New Configuration for"}{" "}
                                    {this.props.editingConfiguration.name}
                                </h1>
                                <button onClick={this.clickCancel}>
                                    Cancel
                                </button>
                            </div>
                            <div className="container">
                                <ConfigurationStepper
                                    pages={this.state.pages}
                                    selectedPage={this.state.selectedPage}
                                    onSelect={this.onSelect}
                                />
                            </div>
                            <div
                                className={`container ${
                                    this.isDetail ? "readonly" : ""
                                }`}
                            >
                                <TransitionGroup>
                                    <CSSTransition
                                        key={this.state.selectedPage.id}
                                        timeout={600}
                                        classNames="fade-tabs"
                                    >
                                        {this.state.selectedPage.component}
                                    </CSSTransition>
                                </TransitionGroup>
                            </div>
                            <div
                                className={`navigation container ${
                                    hasOnlyPrev && "left"
                                } ${hasOnlyNext && "right"}`}
                            >
                                {!hasOnlyNext && (
                                    <button
                                        className="prev"
                                        onClick={this.previousPage}
                                    >
                                        Previous
                                    </button>
                                )}
                                {!hasOnlyPrev && (
                                    <button
                                        className="next"
                                        onClick={this.nextPage}
                                    >
                                        Next Step
                                    </button>
                                )}
                                {!this.isDetail && hasOnlyPrev && (
                                    <button
                                        className={`next ${
                                            this.props
                                                .submitingConfigurationLoading
                                                ? "loading"
                                                : ""
                                        }`}
                                        disabled={
                                            !this.checkValid({
                                                configFormValid:
                                                this.props.configFormValid
                                            })
                                        }
                                        onClick={this.confirmStrayGroups}
                                    >
                                        Save Configuration
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <Dialog
                        open={this.state.cancelDialog}
                        onConfirm={this.cancelConfig}
                        onClose={this.closeCancelDialog}
                        addedClassName={"config-cancel-dialog"}
                        confirmLabel={"Yes, cancel my configuration"}
                        cancelLabel={"No, i've changed my mind"}
                    >
                        <img
                            src="/images/attention.png"
                            width="268"
                            height="230"
                        />
                        <h2>
                            Are you sure you want to cancel the configuration in
                            progress?
                        </h2>
                        <p>
                            Once you cancel this configuration, all changes and
                            settings made so far will be erased.
                        </p>
                    </Dialog>
                    <Dialog
                        open={this.state.showUnchangedDialog}
                        onConfirm={this.cancelUnchangedDialog}
                        hideCancel={true}
                        addedClassName={"config-cancel-dialog"}
                        confirmLabel={"Ok, Review configuration"}
                    >
                        <img
                            src="/images/attention.png"
                            width="268"
                            height="230"
                        />
                        <h2>Not possible to save this configuration.</h2>
                        <p>
                            This configuration seems to have been inaltered. To
                            save a new version of a configuration, first make
                            some changes to it.
                        </p>
                    </Dialog>
                    <Dialog
                        open={this.state.showStrayGroupsDialog}
                        onConfirm={this.continueStrayGroupsDialog}
                        onClose={this.cancelStrayGroupsDialog}
                        addedClassName={"config-success-dialog"}
                        confirmLabel={"Continue"}
                        cancelLabel={"Review configuration settings"}
                    >
                        <img
                            src="/images/attention.png"
                            width="268"
                            height="230"
                        />
                        <h2>
                            This configuration has some groups not assigned.
                        </h2>
                        <p>
                            This configuration seems to have some groups not
                            assigned to a progressive or special prize. If you
                            continue these groups won't be saved, only the ones
                            in use.
                        </p>
                    </Dialog>
                    {this.props.submitingConfigurationState && (
                        <Dialog
                            open={
                                this.props.submitingConfigurationState.error ==
                                true &&
                                this.props.submitingConfigurationState
                                    .success == false
                            }
                            onConfirm={this.closeSubmitingDialog}
                            addedClassName={"config-error-dialog"}
                            confirmLabel={"Review configuration settings"}
                            hideCancel
                        >
                            <img
                                src="/images/error.png"
                                width="268"
                                height="230"
                            />
                            <h2>Oh no, something went wrong...</h2>
                            {this.props.submitingConfigurationState.message && (
                                <p>
                                    {
                                        this.props.submitingConfigurationState
                                            .message
                                    }
                                </p>
                            )}
                            {!this.props.submitingConfigurationState
                                .message && (
                                <p>
                                    Sorry but the was a system error. Go back to
                                    setup and please validate and repeat the
                                    process.
                                </p>
                            )}
                        </Dialog>
                    )}
                    {this.props.submitingConfigurationState && (
                        <Dialog
                            open={
                                this.props.submitingConfigurationState.error ==
                                false &&
                                this.props.submitingConfigurationState
                                    .success == true
                            }
                            onClose={this.closeSubmitingDialog}
                            onConfirm={this.confirmSubmitSuccess}
                            addedClassName={"config-success-dialog"}
                            confirmLabel={"Go to server details"}
                            hideCancel={true}
                            cancelLabel={"Review configuration settings"}
                        >
                            <img
                                src="/images/hurray.png"
                                width="268"
                                height="230"
                            />
                            <h2>Your configuration is done!</h2>
                            <p>
                                Congratulations, your configuration has been
                                successfully done. Thank you for your time!
                            </p>
                        </Dialog>
                    )}
                </div>
            );
        }
    }
}

const mapStateToProps = state => ({
    schema: configurationsStoreSelectors.schema(state),
    sounds: configurationsStoreSelectors.sounds(state),
    schemaLoading: configurationsStoreSelectors.schemaLoading(state),
    editingConfiguration:
        configurationsStoreSelectors.editingConfiguration(state),
    editingConfigurationLoading:
        configurationsStoreSelectors.editingConfigurationLoading(state),
    submitingConfigurationLoading:
        configurationsStoreSelectors.submitingConfigurationLoading(state),
    submitingConfigurationState:
        configurationsStoreSelectors.submitingConfigurationState(state),
    configFormValid: configurationsStoreSelectors.configFormValid(state),
    uploadedConfiguration:
        configurationsStoreSelectors.uploadedConfiguration(state),
    existingConfiguration:
        configurationsStoreSelectors.existingConfiguration(state),
    regionsLoading: configurationsStoreSelectors.regionsLoading(state),
    progressiveRules: configurationsStoreSelectors.progressiveRules(state)
});

const mapDispatchToProps = {
    getLatestSchema: ConfigurationsActionCreators.getLatestSchema,
    getConfiguration: ConfigurationsActionCreators.getConfiguration,
    clearConfiguration: ConfigurationsActionCreators.clearConfiguration,
    clearSchema: ConfigurationsActionCreators.clearSchema,
    getSoundsServer: ConfigurationsActionCreators.getSoundsServer,
    createConfiguration: ConfigurationsActionCreators.createConfiguration,
    editConfiguration: ConfigurationsActionCreators.editConfiguration,
    clearConfigurationSubmition:
    ConfigurationsActionCreators.clearConfigurationSubmition,
    getRegions: ConfigurationsActionCreators.getRegions,
    getMailingLists: ConfigurationsActionCreators.getMailingLists,
    getProgressivesRules: ConfigurationsActionCreators.getProgressivesRules,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(NewConfigurationPage));
